module.exports = __webpack_public_path__ + "static/media/Shreya_Bhatkhande.79f660c8.jpg";